import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-other1-icon',
  templateUrl: './general-other1.component.html'
})
export class GeneralOther1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
